export default __webpack_public_path__ + "static/media/InstrumentSans-Medium.9cf2e03c.woff2";